import React, { useState, useEffect } from "react";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Button,
  FormControl,
  Box,
  Typography,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "../../Axiosinstance";
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from "../../common";

const CreateUserForm = () => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
    sfid: 0,
    usertype: 0,
    profile_Url: "",
  });

  const [profile_Url, setprofile_Url] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [open, setOpen] = useState(false); // Modal open/close state
  const [admins, setAdmins] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [emailError, setEmailError] = useState('');

  useEffect(() => {

    fetchAdminData();
  }, []);

  const fetchAdminData = async () => {
    try {
      const response = await axios.get("/home/usertype?types=3,6,4");
      setAdmins(response.data); // Assuming API returns an array of admins
      // setLoading(false);
    } catch (error) {
      toast.error("error fetching data")
    }
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (file) {
      setLoading(true); // Start loading spinner
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
      formData.append("public_id", "LMS/profile/" + file.name);

      try {
        const response = await fetch(baseURL, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (data.secure_url !== "") {
          setprofile_Url(data.secure_url);

          setUserData((prevUserData) => ({
            ...prevUserData,  // Keep previous state
            profile_Url: data.secure_url, // Update only the profile_Url
          }));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false); // Stop loading spinner
      }
    }
  };



  const checkEmailExists = async (email) => {
    console.log(email + "email")
    try {
      const response = await axios.get(`/home/check-email`, {
        params: { email }
      });
      return response.data; // Assume backend returns { available: true } if email is not in use
    } catch (error) {
      console.error('Error checking email:', error);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the email already exists
    const emailAvailable = await checkEmailExists(userData.email);

    if (!emailAvailable) {
      setEmailError(true);
      return;
    }

    setSubmitting(true); // Start loading on submit
    try {
      const response = await axios.post(
        "/auth/create-user",
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        fetchAdminData();
        toast.success("User created successfully!");
        clearForm(); // Clear form after success
        setOpen(false)
      } else {
        toast.error("Error creating user");
      }
    } catch (error) {
      console.error("Error submitting user form:", error);
      toast.error("Error creating user");
    } finally {
      setSubmitting(false); // Stop loading on submit

    }
  };

  const clearForm = () => {
    setUserData({
      name: "",
      email: "",
      password: "",
      sfid: 0,
      usertype: 0,
      profile_Url: "",
    });
    setprofile_Url(null); // Clear uploaded image
  };



  const handleDelete = async (userId) => {

    const confirmed = window.confirm("Are you sure you want to delete this user?");
    if (!confirmed) return;

    try {
      const response = await axios.delete(`home/user/${userId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        fetchAdminData();
        toast.success("User deleted successfully!");
        // Optionally, update your UI or fetch the new list of users here
      } else {
        toast.error("Error deleting user");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      toast.error("Error deleting user");
    }
  };


  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    clearForm()
    setOpen(false)
  };


  // Filter admins based on search term
  const filteredAdmins = admins.filter(admin =>
    admin.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    admin.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (

    <>

      <Box sx={{ overflowX: "auto", maxWidth: "100%", margin: "0 auto" }}>
        <TextField
          fullWidth
          label="Search by Name or Email"
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          margin="normal"
        />

        <Button variant="contained" onClick={handleOpen}>
          Create User
        </Button>
        <br />
        <br />
        <Table sx={{ minWidth: 650, maxWidth: "1000px", margin: "0 auto" }}>
          <TableHead>
            <TableRow>
              <TableCell style={{fontWeight:"bold"}}>Name</TableCell>
              <TableCell style={{fontWeight:"bold"}}>Email</TableCell>
            
              <TableCell style={{fontWeight:"bold"}}>User Role</TableCell>
              <TableCell style={{fontWeight:"bold"}}>Profile</TableCell>
              <TableCell style={{fontWeight:"bold"}}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredAdmins.map((admin) => (
              <TableRow key={admin.id}>
                <TableCell>{admin.name.toUpperCase()}</TableCell>
                <TableCell>{admin.email}</TableCell>
                <TableCell>
                  {admin.usertype === 3
                    ? 'Admin'
                    : admin.usertype === 6
                      ?  'Finance Admin'
                      : 'Super Admin'}
                </TableCell>
                {/* <TableCell>{admin.sfid}</TableCell> */}
                <TableCell>
                  {admin.profile_Url ? (
                    <img
                      src={admin.profile_Url}
                      // alt={admin.name}
                      style={{ width: 50, height: 50, borderRadius: "50%" }}
                    />
                  ) : (
                    "No Image"
                  )}
                </TableCell>
                <TableCell >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDelete(admin.id)}>
                    Delete User
                  </Button>

                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      {/* Create User Modal */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Create User</DialogTitle>
        <DialogContent>

          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              padding: 2,
            }}
          >
            {/* Toast Container */}
            <ToastContainer />

            {/* Name */}
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={userData.name}
              onChange={handleInputChange}
              required
              margin="normal"
            />

            {/* Email */}
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={userData.email}
              onChange={handleInputChange}
              required
              type="email"
              margin="normal"
              error={emailError} // Use emailError to control the error state
              helperText={emailError ? 'Email is either invalid or already in use' : ''} // Display appropriate message
            />

            {/* Password */}
            <TextField
              fullWidth
              label="Password"
              name="password"
              value={userData.password}
              onChange={handleInputChange}
              required
              type="password"
              margin="normal"
            />

            {/* User Type */}
            <FormControl fullWidth margin="normal">
              <InputLabel>User Type</InputLabel>
              <Select
                label="usertype"
                name="usertype"
                value={userData.usertype}
                onChange={handleInputChange}
                required
              >
                <MenuItem value={3}>Admin</MenuItem>
                <MenuItem value={4}>Super Admin</MenuItem>
                <MenuItem value={6}>Financial Admin</MenuItem>
              </Select>
            </FormControl>

            {/* Profile Image Upload */}
            <Button
              variant="contained"
              component="label"
              fullWidth
              sx={{ mt: 2 }}
              startIcon={loading && <CircularProgress size={20} />}
              disabled={loading}
            >
              {loading ? "Uploading..." : "Upload Profile Image"}
              <input type="file" accept="image/*" hidden onChange={handleFileUpload} />
            </Button>

            {/* Show uploaded image URL if available */}
            {profile_Url && (
              <Box mt={2} textAlign="center">
                <Typography variant="subtitle1">Uploaded Image Preview:</Typography>
                <img
                  src={profile_Url}
                  alt="Uploaded profile"
                  style={{ maxWidth: "100%", borderRadius: "10px" }}
                />
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>

          <Button onClick={handleClose} disabled={submitting || loading}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={submitting}
            startIcon={submitting && <CircularProgress size={20} />}
          >
            {submitting ? "Creating User..." : "Create User"}
          </Button>

        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateUserForm;
